import { FC } from 'react'
import Layout from 'src/containers/Layout/Layout'
import PostList from 'src/containers/Post/PostList'
import { Category } from 'src/types'

const CoursePage: FC = () => {
  return (
    <Layout>
      <PostList queryKey="course" title="艺术讲堂" category={Category.Course} />
    </Layout>
  )
}

export default CoursePage
